import { CollaborateItemWrapper } from './style';

// Components
import Link from 'components/common/Link';
import Image from 'next/image';
import Text from 'components/common/Text';

const CollaborateItem = ({  webConfig, item: {id, link, image, subtitle, title} }) => {
    return (
        <CollaborateItemWrapper
            key={id}
        >
            <Link 
                to={link}
                params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                className='collaborate-item'
            >
                <div className='icon1'>
                <Image
                    src="/nextasset/images/home/quotate.png"
                    alt={title}
                    width={16}
                    height={13}
                />
                </div>
                
                <div className='icon'>
                <Image
                    src="/nextasset/images/home/quotate1.png"
                    alt={title}
                    width={16}
                    height={13}
                />
                </div>

                <div className='arrow'>
                <Image
                    src="/nextasset/images/home/arrow.png"
                    alt={title}
                    width={103}
                    height={41}
                />
                </div>

                <Image
                    src={image}
                    alt={title}
                    width={100}
                    height={100}
                    className='img'
                />
                <Text 
                    className="title"
                    tag="p"
                >  
                    {title}
                </Text>
                <Text 
                    tag="p"
                    className="subtitle"
                >  
                    {subtitle}
                </Text>
            </Link>
        </CollaborateItemWrapper>
    )
}

export default CollaborateItem;